import { render, staticRenderFns } from "./how-to-download-instagram-photos-without-taking-a-screenshot.vue?vue&type=template&id=4c9e6acd"
import script from "./how-to-download-instagram-photos-without-taking-a-screenshot.vue?vue&type=script&lang=js"
export * from "./how-to-download-instagram-photos-without-taking-a-screenshot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports